export default __webpack_public_path__ + "static/media/News & Announcements.f6f9e7e4.svg";